var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.49140e6c9abe367d2041ffd8da782372.svg#G';
                    var viewUrl = 'sprites.49140e6c9abe367d2041ffd8da782372.svg#view-G';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 13 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };